export default __webpack_public_path__ + "static/media/work-sans-v11-latin-regular.e01a1a05.ttf";